import { DeltaDataset } from 'shell-models-lib';
import { Metamodel } from 'app/model/base/model';
import { FormatTypeCopySource } from './format-type.copysource';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.delta.copySourceType,
    display: [],
    tags: { datasetModel: [Metamodel.modelFor(DeltaDataset)] }
})
export class DeltaSource extends FormatTypeCopySource {
}
